import React from 'react';
import { Search, Database, Clock } from 'lucide-react';
import { BRAND_GREEN, BRAND_GOLD } from '../theme/sucronTheme';


const cards = [
  {
    title: 'Buscar Dados',
    description: 'Consulta auditada de dados internos (resultados, rankings, atletas).',
    icon: Search,
    status: 'Em breve',
  },
  {
    title: 'Resultados',
    description: 'Aguardando query...',
    icon: Database,
    status: null,
  },
  {
    title: 'Historico',
    description: 'Ultimas consultas realizadas pelo seu clube.',
    icon: Clock,
    status: null,
  },
];

const ResearchPage = () => (
  <div className="min-h-screen bg-gray-50 p-6">
    <div className="max-w-7xl mx-auto">
      <h1 className="text-3xl font-extrabold mb-2" style={{ color: BRAND_GREEN }}>
        Consulta de Dados
      </h1>
      <p className="text-gray-500 mb-6">
        Pesquise resultados, atletas e rankings de forma auditada.
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div
              key={c.title}
              className="bg-white rounded-xl border border-gray-200 p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div
                  className="w-10 h-10 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: '#f3f4f6' }}
                >
                  <Icon size={20} style={{ color: BRAND_GREEN }} />
                </div>
                <h2 className="text-xl font-bold" style={{ color: BRAND_GREEN }}>
                  {c.title}
                </h2>
              </div>
              <p className="text-gray-600 text-sm flex-1">{c.description}</p>
              {c.status && (
                <span
                  className="inline-block mt-4 text-xs font-semibold px-3 py-1 rounded-full"
                  style={{ backgroundColor: '#fef3c7', color: BRAND_GOLD }}
                >
                  {c.status}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

export default ResearchPage;
